// @flow
import i18n from 'i18n-js';
import React, { Component } from 'react';
import { Grid, Header, Table } from 'semantic-grab-ui/src';
import type { RuleType } from 'types/rule-types';
import RuleBuilder from './RuleBuilder';

type Props = {
  setRef: Function,
  model: Object,
  config: any,
  type: string,
  hideTitle: boolean,
  extraRuleTypes: Array<RuleType>,
  ruleBuilderSearchParams: Object,
  systemType?: string,
  ruleTypesPassedFromSystem?: boolean,
  ruleTypes?: Array<RuleType>,
};

export default class ShowConditions extends Component {
  props: Props;

  static defaultProps = {
    hideTitle: false,
    extraRuleTypes: [],
  }

  render() {
    const { model, extraRuleTypes, ruleBuilderSearchParams } = this.props;
    return (
      <Grid>
        {(!this.props.hideTitle) && (
          <Grid.Column width={4}>
            <Header as="h3">{this.props.title || i18n.t('rewards_page.fields.rules')}</Header>
          </Grid.Column>
        )}
        <Grid.Column width={(this.props.hideTitle) ? 16 : 12}>
          <Table>
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  <RuleBuilder
                    setRef={this.props.setRef}
                    defaultValue={model}
                    readonly
                    config={this.props.config}
                    type={this.props.type}
                    extraRuleTypes={extraRuleTypes}
                    ruleBuilderSearchParams={ruleBuilderSearchParams}
                    systemType={this.props.systemType}
                    ruleTypes={this.props.ruleTypes}
                    ruleTypesPassedFromSystem={this.props.ruleTypesPassedFromSystem}
                  />
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Grid.Column>
      </Grid>
    );
  }
}

ShowConditions.defaultProps = {
  ruleTypesPassedFromSystem: false,
  systemType: '',
  ruleTypes: [],
};
